import axios from 'axios'

import { baseUrl } from '../constants'
const URL = baseUrl


const config = (token) => { return { headers: { Authorization: `Bearer ${token}`, }, } }
const API_URL = '/api/search/' 

// Create new goal
const search = async (searchData, token) => {
  const response = await axios.post(URL+API_URL, searchData, config(token))
  return response.data
}




const searchService = {
  search
}

export default searchService
